import { FC } from "react";
import './NotYetImpl.scss';

export type NotYetImplProps = {

};

const NotYetImpl: FC<NotYetImplProps> = (props) => {

  return <p className="body-subtext">This operation is not yet implemented.</p>;
}

export default NotYetImpl;
